import log from "@/util/log";

class NFCRepository {

  async readDeviceType(session) {
    const flagDataView = await session.readSingleBlock(0x1c);
    return flagDataView.getUint8(1);

  }

  async readDeviceFlag(session, isSupportLevel) {
    const flagDataView = await session.readSingleBlock(0x19);
    return flagDataView.getUint8(3);
  }

  async writeDeviceBattery(session, maxSecond) {
    let hexMaxSecond       = parseInt(maxSecond).toString(16);
    let hexMaxSecondLength = hexMaxSecond.length;
    while (hexMaxSecondLength < 4) {
      hexMaxSecond = `0${hexMaxSecond}`;
      hexMaxSecondLength += 1;
    }

    // "03e4"
    let oilBatteryList = [];
    for (let i = 0; i < hexMaxSecond.length; i += 2) {
      oilBatteryList.unshift(hexMaxSecond.substr(i, i + 2));
    }
    const oilBatteryStr       = oilBatteryList.join("").toUpperCase();
    const oilBatteryAsciiList = [];
    for (let i = 0; i < oilBatteryStr.length; i++) {
      oilBatteryAsciiList.push(oilBatteryStr.charCodeAt(i));
    }
    const sendMaxSecondDataView = new DataView(
      Buffer.from(new Uint8Array(oilBatteryAsciiList)).buffer
    );

    await session.writeSingleBlock(0x13, sendMaxSecondDataView);
  }

  async clearFlag(session, isSupportLevel) {
    if (!isSupportLevel) {
      //清空标志0xFB标志
      const block3 = await session.readSingleBlock(22);
      block3.setInt8(3, 0);
      await session.writeSingleBlock(22, block3);
    } else {
      //清空标志0xFB标志
      const block3 = await session.readSingleBlock(0x1a);
      block3.setInt8(3, 0);
      await session.writeSingleBlock(0x1a, block3);
    }
  }

  async setFlag(session, isSupportLevel, flag) {
    if (!isSupportLevel) {
      //清空标志0xFB标志
      const block3 = await session.readSingleBlock(22);
      block3.setInt8(3, flag);
      await session.writeSingleBlock(0x16, block3);
    } else {
      //清空标志0xFB标志
      const block3 = await session.readSingleBlock(0x1a);
      block3.setInt8(3, flag);
      await session.writeSingleBlock(0x1a, block3);
    }
  }

  async writeDeviceLevel(session, currentLevel) {
    const levelDataView = new DataView(Buffer.alloc(4).buffer);
    levelDataView.setUint8(0, currentLevel);
    await session.writeSingleBlock(0x1b, levelDataView);
  }

  async writeDeviceCurve(session, writerSetting, currentLevel, flag = SUFFIX_FLAG) {

    let versionFeature   = 4;
    let isSupportPreheat = false;
    let isSupportNfc     = false;

    //#region ap02
    const clearPuff = !!writerSetting.clearPuff ? 1 : 0;
    if (currentLevel > 0) {
      //生成写入数据
      const originMultiCurveDataView = await session.readMultipleBlock(
        0x14 + (currentLevel - 1) * 2,
        0x14 + currentLevel * 2 + 1
      );
      isSupportPreheat               = writerSetting.isSupportPreheat;
      isSupportNfc                   = writerSetting.isSupportNfc;
      const block1                   = (versionFeature << 4) | clearPuff << 2 | (isSupportPreheat ? 1 : 0) | ((isSupportNfc ? 1 : 0) << 1);
      if (currentLevel == 1) {
        originMultiCurveDataView.setUint8(0, block1);
      }
      const startPosition = 2;
      writerSetting.diyVoltage.forEach((item, index) => {
        originMultiCurveDataView.setUint8(
          startPosition  + index,
          Math.abs(item / 100)
        );
        log(
          `当前电压等级: ${currentLevel} 写入的电压 ${index + 1} => ${Math.abs(
            item / 100
          )}`
        );
      });
      const packet = originMultiCurveDataView.byteLength / 4;
      for (let i = 0; i < packet; i++) {
        log(`写入的位置 ${0x14 + (currentLevel - 1) * 2 + i}`);
        await session.writeSingleBlock(
          0x14 + (currentLevel - 1) * 2 + i,
          new DataView(originMultiCurveDataView.buffer.slice(i * 4, i * 4 + 4))
        );
      }
      const firstBlock = await session.readSingleBlock(0x14);
      if (firstBlock.getUint8(1) === 0) {
        const originData = new DataView(writerSetting.generateNfcCommand().buffer.slice(0, 4));
        originData.setUInt8(2, firstBlock.getUint8(2));
        originData.setUint8(3, firstBlock.getUint8(3));
        await session.writeSingleBlock(0x14, originData);
      }
      await this.setFlag(session, currentLevel > 0, flag);
    } else {

      const dataView = writerSetting.generateNfcCommand(flag);
      //生成写入数据
      const packet   = dataView.byteLength / 4;
      for (let i = 0; i < packet; i++) {
        await session.writeSingleBlock(
          20 + i,
          new DataView(dataView.buffer.slice(i * 4, i * 4 + 4))
        );
      }
    }


    //#ifdef OUTPUT_DURATION
    console.log(`输出间隔 开启 ${writerSetting.outputDurationValue}`);
    const outputDurationDataView = await session.readSingleBlock(0x1b);
    if (writerSetting.isEnableOutputDuration) {
      outputDurationDataView.setUint8(1, parseInt(writerSetting.outputDurationValue) / 10);
    }
    if (writerSetting.isEnableTemperatureOutput) {
      outputDurationDataView.setUint8(2, parseInt(writerSetting.temperatureOutputValue));
    }
    await session.writeSingleBlock(0x1b, outputDurationDataView);
    //#endif
  }

  async writeTemperature(session, writerSetting, currentLevel, flag = SUFFIX_FLAG) {
    if (currentLevel > 0) {
      throw "No support multiple curves current version";
    } else {
      //生成写入数据
      const dataView = writerSetting.generateNfcTemperatureCommand(flag);
      const packet   = dataView.byteLength / 4;
      for (let i = 0; i < packet; i++) {
        await session.writeSingleBlock(
          20 + i,
          new DataView(dataView.buffer.slice(i * 4, i * 4 + 4))
        );
      }
      if (writerSetting.isEnableStronger) {
        const dataView = new DataView(Buffer.alloc(4).buffer);
        dataView.setUint16(0, writerSetting.strongValue, true);
        await session.writeSingleBlock(
          0x1c,
          dataView
        );
      }
    }
  }

  async readDeviceVoltages() {
    //生成写入数据
    const originMultiCurveDataView = await session.readMultipleBlock(
      0x14,
      0x1b
    );

    const originDiyVoltages   = new DataView(
      originMultiCurveDataView.buffer.slice(2, 27)
    );
    let originDiyVoltagesList = [];
    for (let i = 0; i < originDiyVoltages.byteLength; i++) {
      originDiyVoltagesList.push(originDiyVoltages.getUint8(i) * 100);
    }

    return originMultiCurveDataView;
  }
}

const nfcRepository = new NFCRepository();
export default nfcRepository;


//11 电量 12当前秒数 13最大秒数
export class OilBattery {
  battery       = "E40C";
  currentSecond = "0000";
  maxSecond     = "0000";

  constructor(dataView) {
    if (dataView.byteLength === 12) {
      //3个块 12个字节
      this.battery       = String.fromCharCode(
        dataView.getUint8(0),
        dataView.getUint8(1),
        dataView.getUint8(2),
        dataView.getUint8(3)
      );
      this.currentSecond = String.fromCharCode(
        dataView.getUint8(4),
        dataView.getUint8(5),
        dataView.getUint8(6),
        dataView.getUint8(7)
      );
      this.maxSecond     = String.fromCharCode(
        dataView.getUint8(8),
        dataView.getUint8(9),
        dataView.getUint8(10),
        dataView.getUint8(11)
      );
    }

    this.toString();
  }

  generateNfcCommand() {
    const batteryChars       = Array.from(this.battery);
    const currentSecondChars = Array.from(this.currentSecond);
    const maxSecondChars     = Array.from(this.maxSecond);
    //这里需要对齐，所以写入的数据为36个
    const dataView           = new DataView(Buffer.alloc(12).buffer);
    let i                    = 0;
    batteryChars.forEach((item) => {
      dataView.setUint8(i, item);
      i++;
    });
    currentSecondChars.forEach((item) => {
      dataView.setUint8(i, item);
      i++;
    });
    maxSecondChars.forEach((item) => {
      dataView.setUint8(i, item);
      i++;
    });
    return dataView;
  }

  getMaxSecond() {
    console.log(`first = ${this.maxSecond.substring(0, 2)}`);
    console.log(`second = ${this.maxSecond.substring(2, 4)}`);
    return new DataView(Buffer.of(
      parseInt(this.maxSecond.substring(0, 2), 16),
      parseInt(this.maxSecond.substring(2, 4), 16)
    ).buffer).getUint16(0, true);
  }

  toString() {
    log(
      `设备电量值为 ${this.battery} 设备秒数为 ${this.currentSecond} 最大秒数为 ${this.maxSecond}`
    );
  }
}

//







export const SUFFIX_FLAG = 0xf9;


/**
 export const SUFFIX_FLAG = (function() {
 switch (process.env.CUSTOMER) {
 case "unicoure":
 return 0xfa
 case "avd":
 return 0xfc;
 case "joecig":
 return 0xfe;
 case "tessie":
 return 0xfe
 }
 })()
 */